const ActionType = {
    PLUSH_ORDER : 'PLUSH_ORDER',
    MINUS_ORDER : 'MINUS_ORDER',
    TOKEN_REDUCER : 'TOKEN_REDUCER',
    USER_REDUCER : 'USER_REDUCER'
}

export default ActionType;


// WEBPACK FOOTER //
// ./src/redux/reducer/globalActionType.js